"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEntityEmpty = exports.getEntityArray = exports.getEntity = void 0;

var _isEmpty2 = _interopRequireDefault(require("lodash/fp/isEmpty"));

var _isObject2 = _interopRequireDefault(require("lodash/fp/isObject"));

var _isNil2 = _interopRequireDefault(require("lodash/fp/isNil"));

var _map2 = _interopRequireDefault(require("lodash/fp/map"));

var _flow2 = _interopRequireDefault(require("lodash/fp/flow"));

var _curry2 = _interopRequireDefault(require("lodash/fp/curry"));

var _prop2 = _interopRequireDefault(require("lodash/fp/prop"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getEntity = (0, _curry2.default)(function (keyPath, state) {
  return (0, _prop2.default)("entities." + keyPath, state);
});
exports.getEntity = getEntity;
var getEntityArray = (0, _curry2.default)(function (keyPath, state) {
  return (0, _flow2.default)((0, _prop2.default)("entities[" + keyPath + "]"), (0, _map2.default)(function (value) {
    return value;
  }))(state);
});
exports.getEntityArray = getEntityArray;
var isEntityEmpty = (0, _curry2.default)(function (keyPath, state) {
  var result = getEntity(keyPath)(state);
  return (0, _isNil2.default)(result) || (0, _isObject2.default)(result) && (0, _isEmpty2.default)(result);
});
exports.isEntityEmpty = isEntityEmpty;